import { useState, type MouseEvent } from 'react';
import type { UserListEntry } from '../lib/types.js';
import { rankLabel } from '../lib/ranks.js';
import { statusColor, statusLabel } from '../lib/status.js';
import { ProfileTooltip } from './ProfileTooltip.js';
import { RadioStatus } from './RadioStatus.js';

interface Props {
    users: UserListEntry[];
    nowPlaying?: { title: string; artist: string; url?: string } | null;
    onUser?: (u: UserListEntry, ev: MouseEvent) => void;
}

interface HoverState { user: UserListEntry; x: number; y: number; }

export function UserList({ users, nowPlaying = null, onUser }: Props) {
    const sorted = [...users].sort((a, b) => a.k - b.k || a.name.localeCompare(b.name));
    const [hover, setHover] = useState<HoverState | null>(null);
    return (
        <aside className="user-list">
            <RadioStatus nowPlaying={nowPlaying} />
            <ul>
                {sorted.map(u => (
                    <li key={u.id}
                        className="user"
                        title={`${rankLabel(u.k)} — ${statusLabel(u.uStatus)}`}
                        onClick={(ev) => onUser?.(u, ev)}
                        onMouseEnter={(ev) => setHover({ user: u, x: ev.clientX, y: ev.clientY })}
                        onMouseLeave={() => setHover(null)}>
                        <span className="user-status-dot"
                              style={{ background: statusColor(u.uStatus) }}
                              title={statusLabel(u.uStatus)} />
                        {u.avatar && <img className="user-avatar" src={u.avatar} alt="" />}
                        <span className="user-name" style={{ color: u.color }}>{u.name}</span>
                        {u.is_admin && <span className="user-badge" title="Administrator">A</span>}
                        {u.is_mod && !u.is_admin && <span className="user-badge" title="Moderator">M</span>}
                    </li>
                ))}
            </ul>
            {hover && <ProfileTooltip user={hover.user} x={hover.x} y={hover.y} />}
        </aside>
    );
}
